(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
(function(){
  const init = (sectionEl)=>{
    if (!sectionEl || sectionEl.dataset.faqEnhanced === '1') return;
    sectionEl.dataset.faqEnhanced = '1';
    const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const items = Array.from(sectionEl.querySelectorAll('details.faq-item'));

    const closeItem = (det)=>{
      const content = det.querySelector('.faq-content');
      if(!content){ det.removeAttribute('open'); return; }
      if(!det.hasAttribute('open')) return;
      if(prefersReduce){ det.removeAttribute('open'); return; }
      const start = content.scrollHeight;
      content.style.height = start + 'px';
      requestAnimationFrame(()=>{
        content.style.height = '0px';
        const done = ()=>{ content.removeEventListener('transitionend', done); det.removeAttribute('open'); };
        content.addEventListener('transitionend', done);
      });
    };

    const openItem = (det)=>{
      const content = det.querySelector('.faq-content');
      if(!content) return;
      items.forEach((other)=>{ if(other !== det) closeItem(other); });
      if(det.hasAttribute('open')) return;
      if(prefersReduce){ det.setAttribute('open',''); return; }
      det.setAttribute('open','');
      content.style.height = '0px';
      requestAnimationFrame(()=>{
        const end = content.scrollHeight;
        content.style.height = end + 'px';
        const done = ()=>{ content.removeEventListener('transitionend', done); content.style.height = 'auto'; };
        content.addEventListener('transitionend', done);
      });
    };

    items.forEach((det)=>{
      const content = det.querySelector('.faq-content');
      if(det.hasAttribute('open') && content){ content.style.height = content.scrollHeight + 'px'; }
      const summary = det.querySelector('summary');
      if(!summary) return;
      const onActivate = (ev)=>{
        if (ev.type === 'keydown' && !(ev.key === 'Enter' || ev.key === ' ')) return;
        ev.preventDefault();
        det.hasAttribute('open') ? closeItem(det) : openItem(det);
      };
      summary.addEventListener('click', onActivate);
      summary.addEventListener('keydown', onActivate);
    });
  };

  const ready = ()=>{
    document.querySelectorAll('[id^="shopify-section-"]').forEach((section)=>{
      if (section.querySelector('.faqs-bg')) init(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', (e)=>{
    const section = document.getElementById(e.detail.sectionId);
    if (section && section.querySelector('.faqs-bg')) init(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const drawer = document.getElementById('nav-drawer');
  const openBtn = document.querySelector('.header__hamburger');
  const closeBtn = drawer && drawer.querySelector('.nav-drawer__close');

  const openDrawer = () => {
    if (!drawer || drawer.open) return;
    drawer.classList.remove('is-closing');
    drawer.showModal();
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    openBtn?.setAttribute('aria-expanded', 'true');
  };

  const closeDrawer = () => {
    if (!drawer || !drawer.open || drawer.classList.contains('is-closing')) return;
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    openBtn?.setAttribute('aria-expanded', 'false');

    const handleTransitionEnd = (event) => {
      if (event.target !== drawer) return;
      drawer.removeEventListener('transitionend', handleTransitionEnd);
      drawer.classList.remove('is-closing');
      drawer.close();
    };

    drawer.addEventListener('transitionend', handleTransitionEnd, { once: true });
  };

  if (openBtn && drawer) {
    openBtn.addEventListener('click', openDrawer);
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  // Cart Drawer setup
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartButton = document.querySelector('[data-cart-open]');
  const cartClose = cartDrawer && cartDrawer.querySelector('.cd-close');

  function syncCartFooterSpace() {
    if (!cartDrawer) return;
    const footer = cartDrawer.querySelector('.cd-footer');
    if (!footer) return;
    cartDrawer.style.setProperty('--cd-footer-height', `${Math.ceil(footer.offsetHeight)}px`);
  }

  function cartOpenDrawer() {
    if (!cartDrawer || cartDrawer.open) return;
    cartDrawer.classList.remove('is-closing');
    cartDrawer.showModal();
    requestAnimationFrame(() => {
      syncCartFooterSpace();
      cartDrawer.classList.add('is-open');
    });
    if (cartOverlay) cartOverlay.classList.add('is-open');
    refreshCart();
  }

  function cartCloseDrawer() {
    if (!cartDrawer || !cartDrawer.open || cartDrawer.classList.contains('is-closing')) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.classList.add('is-closing');
    let closed = false;
    const done = (e) => {
      if (e && e.target !== cartDrawer) return;
      if (closed) return;
      closed = true;
      cartDrawer.removeEventListener('transitionend', done);
      cartDrawer.classList.remove('is-closing');
      cartDrawer.close();
    };
    cartDrawer.addEventListener('transitionend', done, { once: true });
    // Fallback in case transitionend is not fired (some mobile browsers)
    setTimeout(done, 450);
    if (cartOverlay) cartOverlay.classList.remove('is-open');
  }

  function formatMoney(cents) {
    const value = (cents || 0) / 100;
    try {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined;
      return new Intl.NumberFormat(undefined, currency ? { style: 'currency', currency } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    } catch(_) {
      return value.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function findBundleSelection(value) {
    if (!value) return '';
    let parsed = value;
    if (typeof parsed === 'string') {
      try {
        parsed = JSON.parse(parsed);
      } catch(_) {
        return /^buy\\b/i.test(parsed) ? parsed : '';
      }
    }

    const queue = [parsed];
    const fallback = [];
    while (queue.length) {
      const current = queue.shift();
      if (!current) continue;
      if (typeof current === 'string') {
        const clean = current.trim();
        if (/^buy\\b/i.test(clean)) return clean;
        if (/\\bfree\\b|\\bsave\\b/i.test(clean)) fallback.push(clean);
        continue;
      }
      if (Array.isArray(current)) {
        current.forEach((item) => queue.push(item));
        continue;
      }
      if (typeof current === 'object') {
        ['title', 'name', 'label', 'dealTitle', 'barTitle', 'optionName'].forEach((key) => {
          if (current[key]) queue.unshift(current[key]);
        });
        Object.keys(current).forEach((key) => queue.push(current[key]));
      }
    }
    return fallback[0] || '';
  }

  function getBundleSelection(item) {
    const props = item && item.properties ? item.properties : {};
    if (props.Bundle) return props.Bundle;

    const kaching = props.__kaching_bundles || props._kaching_bundles || props.kaching_bundles;
    const fromKaching = findBundleSelection(kaching);
    if (fromKaching) return fromKaching;

    if (kaching || item.selling_plan_allocation) {
      if (item.quantity === 1) return 'Buy One';
      if (item.quantity === 3) return 'Buy 2 + Get 1 FREE';
      if (item.quantity === 5) return 'Buy 3 + Get 2 FREE';
    }
    return '';
  }

  function getDeliveryFrequency(item) {
    if (!item || !item.selling_plan_allocation) return '';
    const planName = item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name;
    const option = item.selling_plan_allocation.selling_plan
      && item.selling_plan_allocation.selling_plan.options
      && item.selling_plan_allocation.selling_plan.options[0]
      && item.selling_plan_allocation.selling_plan.options[0].value;
    const text = option || planName || '';
    if (/month|30\\s*days/i.test(text)) return 'Deliver every 30 days';
    return text || 'Deliver every 30 days';
  }

  $(document).on('click', '.cd-remove-item', function () {
    const $btn = $(this);
    const $item = $btn.closest('.cd-item');
    const $qtyVal = $item.find('.cd-qty-val');
    const $decBtn = $item.find('.cd-qty-btn[data-action="decrease"]');

    if ($btn.is(':disabled')) return;

    $btn.prop('disabled', true);

    let qty = parseInt($qtyVal.text(), 10);
    if (!qty || qty < 1) return;

    while (qty > 0) {
        $decBtn.trigger('click');
        qty--;
    }
});
  function renderCart(cart) {
    const content = cartDrawer && cartDrawer.querySelector('#cd-content');
    if (!content) return;
    if (!cart || !cart.items || cart.items.length === 0) {
      content.innerHTML = '<div class="cd-empty">Your cart is empty.</div>';
      const sub = cartDrawer.querySelector('.cd-sub-val');
      if (sub) sub.textContent = formatMoney(0);
      requestAnimationFrame(syncCartFooterSpace);
      return;
    }
    const itemsHtml = cart.items.map((item, idx) => {
      const selection = getBundleSelection(item);
      const bundle = selection ? `<div class="cart__item--variants"><span class="variant-label">Selection:</span><span class="variant-value">${escapeHtml(selection)}</span></div>` : '';
      const qtyLine = `<div class="cart__item--variants"><span class="variant-label">Quantity:</span><span class="variant-value">${item.quantity}</span></div>`;
      const wasPrice = item.original_line_price > item.final_line_price ? `<s style="opacity:.55;font-size:.8em;margin-right:6px">${formatMoney(item.original_line_price)}</s>` : '';
      const frequency = getDeliveryFrequency(item);
      const delivery = frequency ? `<div class="cart__item--frequency">${escapeHtml(frequency)}</div>` : '';
      const imgSrc = item.image ? `${item.image}?width=240` : '';
      return `<li class="cd-item" data-line="${idx+1}">
        <a class="cd-thumb" href="${item.url}">${imgSrc ? `<img class=\"cd-img\" alt=\"${item.product_title}\" src=\"${imgSrc}\"/>` : ''}</a>
        <div class="cd-info">
          <a class="cd-name" href="${item.url}">${item.product_title}</a>
          ${bundle}${qtyLine}${delivery}
          <div class="cd-row">
            <div  >

               <button
    class="cd-remove-item"
    aria-label="Remove item"
    title="Remove"
  >
    🗑
  </button>
  
              <button style="display:none" class="cd-qty-btn" data-action="decrease" aria-label="Decrease">-</button>
              <span style="display:none" class="cd-qty-val" aria-live="polite">${item.quantity}</span>
              <button style="display:none" class="cd-qty-btn" data-action="increase" aria-label="Increase">+</button>
            </div>
            <div class="cd-price">${wasPrice}${formatMoney(item.final_line_price)}</div>
          </div>
        </div>
      </li>`;
    }).join('');
    content.innerHTML = `<ul class="cd-items" role="list">${itemsHtml}</ul>`;
    const subtotalEl = cartDrawer.querySelector('.cd-sub-val');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    requestAnimationFrame(syncCartFooterSpace);
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
    } catch(_) {}
  }

  async function changeLine(line, quantity) {
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      await refreshCart();
    } catch(_) {}
  }

  // expose a global opener for any external scripts
  window.cartOpen = cartOpenDrawer;
  if (cartButton && cartDrawer) {
    cartButton.addEventListener('click', (e) => { e.preventDefault(); cartOpenDrawer(); });
  }
  if (cartClose && cartDrawer) {
    cartClose.addEventListener('click', cartCloseDrawer);
  }
  if (cartOverlay) { cartOverlay.addEventListener('click', cartCloseDrawer); }
  if (cartDrawer) {
    const footer = cartDrawer.querySelector('.cd-footer');
    if (footer && window.ResizeObserver) {
      new ResizeObserver(syncCartFooterSpace).observe(footer);
    }
    window.addEventListener('resize', syncCartFooterSpace);
    cartDrawer.addEventListener('cancel', (e) => { e.preventDefault(); cartCloseDrawer(); });
    cartDrawer.addEventListener('click', (e) => {
      // Handle qty changes
      const btn = e.target.closest('.cd-qty-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const itemEl = btn.closest('.cd-item');
        if (itemEl) {
          const line = parseInt(itemEl.getAttribute('data-line'), 10);
          const qtyEl = itemEl.querySelector('.cd-qty-val');
          const wrap = btn.closest('.cd-qty');
          const controls = wrap ? wrap.querySelectorAll('.cd-qty-btn') : [];
          const current = parseInt(qtyEl && qtyEl.textContent, 10) || 1;
          const next = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
          // Optimistic UI update
          if (qtyEl) qtyEl.textContent = String(next);
          controls.forEach(b => b.disabled = true);
          changeLine(line, next).finally(() => controls.forEach(b => b.disabled = false));
        }
        return;
      }
      // Close when clicking backdrop/edge
      if (e.target === cartDrawer) { cartCloseDrawer(); return; }
      const wrap = cartDrawer.querySelector('.cd-wrap');
      if (!wrap) return;
      if (!wrap.contains(e.target) || e.target.classList.contains('cd-backdrop')) cartCloseDrawer();
    });
  }
  if (drawer) {
    drawer.addEventListener('close', () => {
      drawer.classList.remove('is-open', 'is-closing');
      openBtn?.setAttribute('aria-expanded', 'false');
    });

    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) {
        closeDrawer();
      }
    });
  }

  // Delegated handler so clicks on nested SVGs or dynamically replaced header still open drawer
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cart-open]');
    if (!trigger) return;
    e.preventDefault();
    cartOpenDrawer();
  });

  // Delegated handler for hamburger menu as well
  document.addEventListener('click', (e) => {
    const hb = e.target.closest('.header__hamburger');
    if (!hb) return;
    e.preventDefault();
    openDrawer();
  });

  // Outside-click close handled by overlay (#cart-overlay) and dialog backdrop (cd-backdrop)

  // Rebind on section reload in Theme Editor
  document.addEventListener('shopify:section:load', (e) => {
    if (!e.detail || !e.detail.sectionId) return;
    const section = document.getElementById(e.detail.sectionId);
    if (!section) return;
    if (section.querySelector('[data-cart-open]')) {
      // open on click will be handled by delegated listener
      // refresh content in case of updated cart
      if (cartDrawer) refreshCart();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
